"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageView = exports.PackageTransferState = exports.PackageState = void 0;
// List of Package statuses
var PackageState;
(function (PackageState) {
    PackageState["DELETED"] = "deleted";
    PackageState["EXPIRED"] = "expired";
    PackageState["HELD"] = "held";
    PackageState["RELEASED"] = "released";
})(PackageState = exports.PackageState || (exports.PackageState = {}));
// List of Package transfer statuses
var PackageTransferState;
(function (PackageTransferState) {
    PackageTransferState["IN_PROGRESS"] = "IN PROGRESS";
    PackageTransferState["COMPLETE"] = "COMPLETE";
    PackageTransferState["FAILED"] = "FAILED";
    PackageTransferState["STOPPED"] = "STOPPED";
    PackageTransferState["QUEUED"] = "QUEUED";
    PackageTransferState["REMOVED"] = "REMOVED";
    PackageTransferState["WILLRETRY"] = "WILLRETRY";
})(PackageTransferState = exports.PackageTransferState || (exports.PackageTransferState = {}));
// List of Package views
var PackageView;
(function (PackageView) {
    PackageView["DETAILS"] = "details";
    PackageView["INBOX"] = "inbox";
    PackageView["RECEIVED"] = "received";
    PackageView["SENT"] = "sent";
})(PackageView = exports.PackageView || (exports.PackageView = {}));
